import {take, call, put, select} from 'redux-saga/effects'
import {intToHexString} from '../utils'

import {
  SENDING_PRESENTATION_REQUEST,
  FETCH_PRESENTATION_REQUEST,
  FECTH_PRESENTATION_SUCCESS,
  FECTH_PRESENTATION_FAILURE,
  MQTT_NEW_ALARM_STATE_RECEIVE,
  MQTT_STATION_CONNECTION_STATUS_RECEIVE,
  MQTT_NEW_STATTION_STATE_RECEIVE
} from '../actions/constants'
import presentation from '../api/presentation'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;
const getStationsFromState = (state) => state.presentation.stations;

function* presentationRequest({token, systemID}) {
  yield put({type: SENDING_PRESENTATION_REQUEST, sending: true})
  try {
    return yield call(presentation.fetchPresentations, token, systemID)
  } catch (error) {
    yield put({type: FECTH_PRESENTATION_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_PRESENTATION_REQUEST, sending: false})
  }
}

export function* watchPresentationRequest() {
  while (true) {
    yield take(FETCH_PRESENTATION_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(presentationRequest, {token, systemID})
    const arr = yield call(putNotify, {response})
    const stations = Array.isArray(arr)
      ? arr
      : []
    const hardwareIDHexStations = stations.map((station) => {
      return {
        ...station,
        HardwareIDHex: intToHexString(station.HardwareID)
      }
    })
    hardwareIDHexStations.sort((a, b) => {
      return b.AlarmCount - a.AlarmCount
    })
    yield put({type: FECTH_PRESENTATION_SUCCESS, stations: hardwareIDHexStations});
  }
}

export function* watchNewStationAlarmUpdated() {
  while (true) {
    const {newAlarmState} = yield take(MQTT_NEW_ALARM_STATE_RECEIVE)
    const stations = yield select(getStationsFromState)
    const newAlarmStations = stations.map((item) => {
      if (item.ID === newAlarmState.ID) {
        return {
          ...item,
          AlarmLevel: newAlarmState.AlarmLevel,
          AlarmCount: newAlarmState.AlarmCount,
          AlarmList: newAlarmState.AlarmList
        }
      } else {
        return {
          ...item
        }
      }
    })
    newAlarmStations.sort((a, b) => {
      return b.AlarmCount - a.AlarmCount
    })
    yield put({type: MQTT_NEW_STATTION_STATE_RECEIVE, stations: newAlarmStations});
  }
}

export function* watchNewStationConnectionUpdated() {
  while (true) {
    const {newConnectionState} = yield take(MQTT_STATION_CONNECTION_STATUS_RECEIVE)
    const stations = yield select(getStationsFromState)
    const newConnectionStations = stations.map((item) => {
      if (item.ID === newConnectionState.ID) {
        const alarms = newConnectionState.AlarmLevel === 0
          ? []
          : item.AlarmList.filter((a) => {
            return a.AlarmID !== 255
          })
        return {
          ...item,
          AlarmLevel: newConnectionState.AlarmLevel,
          OnlineState: newConnectionState.OnlineState,
          OnlineTime: newConnectionState.OnlineTime
        }
      } else {
        return {
          ...item
        }
      }
    })
    yield put({type: MQTT_NEW_STATTION_STATE_RECEIVE, stations: newConnectionStations});
  }
}



// WEBPACK FOOTER //
// ./src/sagas/presentation.js